// =================================================================================

export const creditsTeam = [
    {
        name: "Victor JAFFEUX",
        role: "Maitre des éléments",
        chibi: require("../assets/images/chibijaff.png"),
    },
    {
        name: "Adrien LAMBEL",
        role: "Amiral du code",
        chibi: require("../assets/images/chibiadri.png"),
    },
    {
        name: "Alex HARBUZINSKI",
        role: "Design d'interface",
        chibi: require("../assets/images/chibialex.png"),
    },
    {
        name: "Mathieu BOUCHONNET",
        role: "Développement",
        chibi: require("../assets/images/chibimath.png"),
    },
    {
        name: "Gabin JIRODET",
        role: "Écriture",
        chibi: require("../assets/images/chibigab.png"),
    },
    {
        name: "Corentin BRASART",
        role: "Musiques et sons",
        chibi: require("../assets/images/chibicorentin.png"),
    },
    {
        name: "Loline BONGIRAUD",
        role: "Illustration",
        chibi: require("../assets/images/chibiloline.png"),
    },
    {
        name: "Émilien MASSEMIN",
        role: "Écriture",
        chibi: require("../assets/images/chibiemilien.png"),
    },
    {
        name: "Martin RINGOT",
        role: "Écriture",
        chibi: require("../assets/images/chibimartin.png"),
    },
    {
        name: "Jessica SOUMIER",
        role: "Illustration",
        chibi: require("../assets/images/chibijess.png"),
    },
    {
        name: "Constance VERMARE",
        role: "Illustration",
        chibi: require("../assets/images/chibiconstance.png"),
    },
    {
        name: "Lucas SORRENTI",
        role: "Illustration",
        chibi: require("../assets/images/chibilucas.png"),
    },
    {
        name: "Laurane MANDIN",
        role: "Communication",
        chibi: require("../assets/images/chibilaurane.png"),
    },
    {
        name: "Eloïse GUR",
        role: "Écriture",
        chibi: require("../assets/images/chibieloise.png"),
    },
];

export const collaborationTeam = [
    {
        name: "Agence TroisPointZéro (Jordan & Vincent)",
        role: "Consulting développement",
    },
    {
        name: "Jasper MARCUS",
        role: "Traduction Anglaise",
    },
    {
        name: "Kessem QUARKS",
        role: "Traduction Anglaise",
    },
    {
        name: "Juan LOPEZ",
        role: "Communication",
    },
    {
        name: "Émilie PESSIEAU",
        role: "Avocate",
    },
    {
        name: "Jonathan SIGNORET",
        role: "Avocat",
    },
    {
        name: "COGECE (Marc, Arthur & Brice)",
        role: "Comptabilité",
    },
    {
        name: "Sarah BEAULIEU",
        role: "Relecture",
    },
    {
        name: "Cindy ASSELIN DE BEAUVILLE",
        role: "Relecture",
    },
    {
        name: "Andrea FIELD",
        role: "Traduction anglaise",
    },
    {
        name: "Florence HOUISSE",
        role: "Avocate",
    },
    {
        name: "Agence VingtDeux (Paul, Romuald, Kevin & Damien)",
        role: "Communication & Stratégie digitale",
    },
    {
        name: "Riot House (Thibault & Damien)",
        role: "Vidéo promotionnelle",
    },
];
export const thanksTeam = [
    {
        name: "Hugo KIHL",
        role: "Merci pour bibu",
    },
    {
        name: "Rémi SALOMON",
        role: "La zone en personne",
    },
    {
        name: "Région Auvergne Rhône-Alpes",
        role: "",
    },
    {
        name: "Fondation ESC Clermont",
        role: "",
    },
    {
        name: "Digital League",
        role: "Un grand merci à Olivier",
    },
    {
        name: "Incubateur SquareLab",
        role: "Merci à Fabrice, Margot et à tous les autres incubés",
    },
    {
        name: "Le Village By CA",
        role: "Merci à Vincent, Catherine, Christophe, Maëlle, Hacene, Myriam et toutes les startups",
    },
    {
        name: "BPI France",
        role: "",
    },
    {
        name: "Le CNC",
        role: "",
    },
    {
        name: "IAIT Auvergne Rhône-Alpes",
        role: "",
    },
    {
        name: "Laurent VICTORINO",
        role: "Merci pour tous ces calls",
    },
    {
        name: "Catherine FARNOUX",
        role: "Merci pour tout ce que tu fais au quotidien et pour ton soutien inconditionnel",
    },
    {
        name: "Les Béta testeurs ❤️",
        role: "",
    },
    {
        name: "Franck RAYNAUD",
        role: "Merci de nous avoir guidé sur le bon chemin",
    },
    {
        name: "Anthony JAUNEAUD",
        role: "Merci pour tes conseils",
    },
    {
        name: "Notre équipe d'acteurs exceptionnels",
        role: "Eugénie, Mathilde, Sam et Raph",
    },
    {
        name: "Nos parents",
        role: "Merci de nous prêter vos maisons, de faire des aller-retours pour rien, d'être nos cobayes et de malgré tout continuer de nous soutenir",
    },
    {
        name: "Charlotte",
        role: "Merci de ton soutien et d'avoir supporté Gabin parler tout seul tout ce temps",
    },
    {
        name: "Tristan",
        role: "Merci de m'aider depuis le début, de me nourrir pendant les périodes de rushs et de ton soutien à toute épreuve",
    },
    {
        name: "Les copains",
        role: "Bastien, Jo, Salom, Lucas, Laura, Arthur, Merci de m'avoir supporté crier tous les jours sur discord",
    },
    {
        name: "Yves",
        role: "Mercyve",
    },
    {
        name: "Marie",
        role: "Merci de m'avoir aidé à pousser le premier domino",
    },
    {
        name: "Les covoitureurs d'Alex",
        role: "Merci de nous avoir autant apporté en faisant semblant de vouloir tester par politesse",
    },
    {
        name: "L'inhérence",
        role: "",
    },
    {
        name: "La cafetière de Corentin",
        role: "",
    },
    {
        name: "Boo, Simba, Sherazade et Pearl",
        role: "",
    },
];

// ------------------------------

// ------------------------------
export const creditsTeamEn = [
    {
        name: "Victor JAFFEUX",
        role: "Master of the elements",
        chibi: require("../assets/images/chibijaff.png"),
    },
    {
        name: "Adrien LAMBEL",
        role: "Code Admiral",
        chibi: require("../assets/images/chibiadri.png"),
    },
    {
        name: "Alex HARBUZINSKI",
        role: "Interface design",
        chibi: require("../assets/images/chibialex.png"),
    },
    {
        name: "Mathieu BOUCHONNET",
        role: "Development",
        chibi: require("../assets/images/chibimath.png"),
    },
    {
        name: "Gabin JIRODET",
        role: "Narrative design",
        chibi: require("../assets/images/chibigab.png"),
    },
    {
        name: "Corentin BRASART",
        role: "Musiques et sons",
        chibi: require("../assets/images/chibicorentin.png"),
    },
    {
        name: "Loline BONGIRAUD",
        role: "2D Art",
        chibi: require("../assets/images/chibiloline.png"),
    },
    {
        name: "Émilien MASSEMIN",
        role: "Narrative design",
        chibi: require("../assets/images/chibiemilien.png"),
    },
    {
        name: "Martin RINGOT",
        role: "Narrative design",
        chibi: require("../assets/images/chibimartin.png"),
    },
    {
        name: "Jessica SOUMIER",
        role: "2D Art",
        chibi: require("../assets/images/chibijess.png"),
    },
    {
        name: "Constance VERMARE",
        role: "2D Art",
        chibi: require("../assets/images/chibiconstance.png"),
    },
    {
        name: "Lucas SORRENTI",
        role: "2D Art",
        chibi: require("../assets/images/chibilucas.png"),
    },
    {
        name: "Laurane MANDIN",
        role: "Communication",
        chibi: require("../assets/images/chibilaurane.png"),
    },
    {
        name: "Eloïse GUR",
        role: "Narrative Design",
        chibi: require("../assets/images/chibieloise.png"),
    },
];

export const collaborationTeamEn = [
    {
        name: "TroisPointZéro Agency (Jordan & Vincent)",
        role: "Development consulting",
    },
    {
        name: "Jasper MARCUS",
        role: "English translation",
    },
    {
        name: "Kessem QUARKS",
        role: "English translation",
    },
    {
        name: "Émilie PESSIEAU",
        role: "Lawyer",
    },
    {
        name: "Jonathan SIGNORET",
        role: "Lawyer",
    },
    {
        name: "Catherine FARNOUX",
        role: "Accounting",
    },
    {
        name: "COGECE (Marc, Arthur & Brice)",
        role: "Accounting",
    },
    {
        name: "Juan LOPEZ",
        role: "Communication",
    },
    {
        name: "Sarah BEAULIEU",
        role: "Proofreading",
    },
    {
        name: "Cindy ASSELIN DE BEAUVILLE",
        role: "Proofreading",
    },
    {
        name: "Andrea FIELD",
        role: "English translation",
    },
    {
        name: "Florence HOUISSE",
        role: "Lawyer",
    },
    {
        name: "VingtDeux Agency (Paul, Romuald, Kevin & Damien)",
        role: "Communication & digital strategy consulting",
    },
    {
        name: "Riot House (Thibault & Damien)",
        role: "Promotional video",
    },
];
export const thanksTeamEn = [
    {
        name: "Hugo KIHL",
        role: "Thanks for bibu",
    },
    {
        name: "Rémi SALOMON",
        role: "The zone himself",
    },
    {
        name: "Auvergne Rhône-Alpes Region",
        role: "",
    },
    {
        name: "ESC Clermont Fondation",
        role: "",
    },
    {
        name: "Digital League",
        role: "Many thanks to Olivier",
    },
    {
        name: "SquareLab Incubator",
        role: "Thanks to Fabrice, Margot and all the others incubated",
    },
    {
        name: "Le Village By CA",
        role: "Thanks to Vincent, Catherine, Christophe, Maëlle and all the others accelerated",
    },
    {
        name: "Laurent VICTORINO",
        role: "Thanks for all these calls",
    },
    {
        name: "Catherine FARNOUX",
        role: "Thank you for everything you do on a daily basis and for your unconditional support",
    },
    {
        name: "Franck RAYNAUD",
        role: "Thank you for guiding us to the right path",
    },
    {
        name: "Anthony JAUNEAUD",
        role: "Thanks for your advices",
    },
    {
        name: "Our team of exceptional actors",
        role: "Eugénie, Mathilde, Sam and Raph",
    },
    {
        name: "Our parents",
        role: "Thank you for lending us your houses, for going back and forth for nothing, for being our guinea pigs and for continuing to support us despite everything",
    },
    {
        name: "Charlotte",
        role: "Thank you for your support and for putting up with Gabin talking to himself all this time",
    },
    {
        name: "Tristan",
        role: "Thank you for helping me from the beginning, for feeding me during the rush periods and for your unfailing support",
    },
    {
        name: "The Buddies",
        role: "Bastien, Jo, Salom, Lucas, Laura, Arthur, thank you for putting up with me shouting on discord every day.",
    },
    {
        name: "Yves",
        role: "Mercyve",
    },
    {
        name: "Marie",
        role: "Thank you for helping me pushing the first domino",
    },
    {
        name: "Alex's carpoolers",
        role: "Thank you for bringing us so much by pretending wanting to test out of politeness",
    },
    {
        name: "The Inherence",
        role: "",
    },
    {
        name: "Corentin's coffee maker",
        role: "",
    },
    {
        name: "Boo, Simba, Sherazade et Pearl",
        role: "",
    },
    {
        name: "Beta testers ❤️",
        role: "",
    },
];

export const termsFr = [
    {
        name: "Propriété intellectuelle",
        text: "Tout contenu publié et mis à disposition sur cette application est la propriété de Victor Jaffeux et de ses créateurs. Cela comprend, mais n’est pas limité aux images, textes, logos, documents, fichiers téléchargeables et tout ce qui contribue à la composition de cette application.",
    },
    {
        name: "Utilisation acceptable",
        text: "En tant qu’utilisateur, vous acceptez d’utiliser notre application légalement et de ne pas utiliser cette application pour des fins illicites, à savoir : Violer les droits de propriété intellectuelle des propriétaires de l'application ou de tout tiers à l'application. Si nous estimons que vous utilisez cette application illégalement ou d’une manière qui viole les conditions d’utilisation acceptable ci-dessus, nous nous réservons le droit de limiter, suspendre ou résilier votre accès à cette application. Nous nous réservons également le droit de prendre toutes les mesures juridiques nécessaires pour vous empêcher d’accéder à notre application.",
    },
    {
        name: "Limitation de responsabilité",
        text: "Victor Jaffeux ou l’un de ses employés sera tenu responsable de tout problème découlant de cette application. Néanmoins, Victor Jaffeux et ses employés ne seront pas tenus responsables de tout problème découlant de toute utilisation irrégulière de cette application.",
    },
    {
        name: "Indemnité",
        text: "En tant qu’utilisateur, vous indemnisez par les présentes Victor Jaffeux de toute responsabilité, de tout coût, de toute cause d’action, de tout dommage ou de toute dépense découlant de votre utilisation de cette application ou de votre violation de l’une des dispositions énoncées dans le présent document.",
    },
    {
        name: "Lois applicables",
        text: "Ce document est soumis aux lois applicables en France et vise à se conformer à ses règles et règlements nécessaires. Cela inclut la réglementation à l’échelle de l’UE énoncée dans le RGPD.",
    },
    {
        name: "Divisibilité",
        text: "Si, à tout moment, l’une des dispositions énoncées dans le présent document est jugée incompatible ou invalide en vertu des lois applicables, ces dispositions seront considérées comme nulles et seront retirées du présent document. Toutes les autres dispositions ne seront pas touchées par les lois et le reste du document sera toujours considéré comme valide.",
    },
    {
        name: "Modifications",
        text: "Ces conditions générales peuvent être modifiées de temps à autre afin de maintenir le respect de la loi et de refléter tout changement à la façon dont nous gérons notre application et la façon dont nous nous attendons à ce que les utilisateurs se comportent sur notre application. Nous recommandons à nos utilisateurs de vérifier ces conditions générales de temps à autre pour s’assurer qu’ils sont informés de toute mise à jour. Au besoin, nous informerons les utilisateurs par courriel des changements apportés à ces conditions ou nous afficherons un avis sur notre application.",
    },
    {
        name: "Contact",
        text: "Veuillez communiquer avec nous si vous avez des questions ou des préoccupations. Nos coordonnées sont les suivantes : contact@talesup.io",
    },
    {
        name: "Date d'entrée en vigueur : ",
        text: "Le 23 août 2020.",
    },
];

export const termsEn = [
    {
        name: "Propriété intellectuelle",
        text: "Tout contenu publié et mis à disposition sur cette application est la propriété de Victor Jaffeux et de ses créateurs. Cela comprend, mais n’est pas limité aux images, textes, logos, documents, fichiers téléchargeables et tout ce qui contribue à la composition de cette application.",
    },
    {
        name: "Utilisation acceptable",
        text: "En tant qu’utilisateur, vous acceptez d’utiliser notre application légalement et de ne pas utiliser cette application pour des fins illicites, à savoir : Violer les droits de propriété intellectuelle des propriétaires de l'application ou de tout tiers à l'application. Si nous estimons que vous utilisez cette application illégalement ou d’une manière qui viole les conditions d’utilisation acceptable ci-dessus, nous nous réservons le droit de limiter, suspendre ou résilier votre accès à cette application. Nous nous réservons également le droit de prendre toutes les mesures juridiques nécessaires pour vous empêcher d’accéder à notre application.",
    },
    {
        name: "Limitation de responsabilité",
        text: "Victor Jaffeux ou l’un de ses employés sera tenu responsable de tout problème découlant de cette application. Néanmoins, Victor Jaffeux et ses employés ne seront pas tenus responsables de tout problème découlant de toute utilisation irrégulière de cette application.",
    },
    {
        name: "Indemnité",
        text: "En tant qu’utilisateur, vous indemnisez par les présentes Victor Jaffeux de toute responsabilité, de tout coût, de toute cause d’action, de tout dommage ou de toute dépense découlant de votre utilisation de cette application ou de votre violation de l’une des dispositions énoncées dans le présent document.",
    },
    {
        name: "Lois applicables",
        text: "Ce document est soumis aux lois applicables en France et vise à se conformer à ses règles et règlements nécessaires. Cela inclut la réglementation à l’échelle de l’UE énoncée dans le RGPD.",
    },
    {
        name: "Divisibilité",
        text: "Si, à tout moment, l’une des dispositions énoncées dans le présent document est jugée incompatible ou invalide en vertu des lois applicables, ces dispositions seront considérées comme nulles et seront retirées du présent document. Toutes les autres dispositions ne seront pas touchées par les lois et le reste du document sera toujours considéré comme valide.",
    },
    {
        name: "Modifications",
        text: "Ces conditions générales peuvent être modifiées de temps à autre afin de maintenir le respect de la loi et de refléter tout changement à la façon dont nous gérons notre application et la façon dont nous nous attendons à ce que les utilisateurs se comportent sur notre application. Nous recommandons à nos utilisateurs de vérifier ces conditions générales de temps à autre pour s’assurer qu’ils sont informés de toute mise à jour. Au besoin, nous informerons les utilisateurs par courriel des changements apportés à ces conditions ou nous afficherons un avis sur notre application.",
    },
    {
        name: "Contact",
        text: "Veuillez communiquer avec nous si vous avez des questions ou des préoccupations. Nos coordonnées sont les suivantes : contact@talesup.io",
    },
    {
        name: "Date d'entrée en vigueur : ",
        text: "Le 23 août 2020.",
    },
];

export const cookies = [
    {
        name: "1. Champ d'application de la Charte",
        text: "La présente Charte a pour vocation de s’appliquer aux supports suivants : L’application mobile Tales Up disponible sur l’App Store d’Apple et le Play Store de Google (ci-après « Application »",
    },
    {
        name: "2. Que sont les cookies et autres traceurs ?",
        text: "Des outils internes ou de partenaires sont installés sur l’Application (ci-après « Outil de traçage ») afin d’accéder et de collecter des données sur votre appareil (ci-après « Identifiants »). Les données pouvant être collectées sont les suivantes : \n\nL’identifiant de l’appareil de l’utilisateur (device ID) ;\nLa version de l’Application installée sur l'appareil de l’utilisateur ;\nLe modèle de l'appareil de l’utilisateur ; \nLa version du système d’exploitation (OS) de l’appareil de l’utilisateur ; \nLe niveau de batterie de l’appareil de l’utilisateur ;\nLa langue configurée sur l’appareil de l’utilisateur ;\nL’identifiant publicitaire de l’appareil (IDFA/GAID) ; \nL'identifiant Push de l’appareil de l’utilisateur ; \nL’opérateur du téléphone ;\nLe pays, et le continent de l’utilisateur ;\nL’adresse IP. \n\nLes Outils de traçage seront désignés, individuellement ou ensemble, par le terme « Traceurs » ci-après.",
    },
    {
        name: "3. Pourquoi Périple Studio utilise des cookies et des Traceurs ?",
        text: "Périple Studio utilise des Traceurs sur son Application pour les finalités listées ci-après.\n\nPour ces finalités, Périple Studio est susceptible de permettre à des partenaires tiers de déposer des cookies ou accéder à des Identifiants et à des cookies sur le disque dur de votre terminal lorsque vous utilisez notre Application.\n\nVotre accord est une priorité pour Périple Studio, ainsi nous vous demandons votre consentement avant tout dépôt de cookies sauf pour ceux répondant à des besoins techniques, ceux-ci étant strictement nécessaires à la navigation sur le site. De même, votre consentement est exigé pour l’utilisation des Traceurs sur l’Application et la collecte des Identifiants par les Outils de traçage. Votre consentement n’est pas requis uniquement dans le cas où les Traceurs sont strictement nécessaires au fonctionnement ou à la sécurité de l’Application.\n\nIl n’y a pas de cookies déposés par les applications mobiles. En revanche, l’Application accède et collecte les Identifiants uniques de votre appareil afin de le reconnaître d’une visite sur l’autre. \nDes outils internes et partenaires et des Traceurs ont été installés sur l’Application afin d’accéder et de collecter les Identifiants.\n\nCes Traceurs permettent à Périple Studio de :\n-s’assurer du bon fonctionnement de l’Application\n-faire fonctionner certaines fonctionnalités\n-si vous y avez consenti,  les utiliser à des fins publicitaires ou d’analyse.\n\nBesoins techniques :\n\nLorsque vous consultez l’Application, des Traceurs dits de sécurité collectent et traitent des données de votre appareil. Ils peuvent être utilisés à des fins d’authentification ou de sécurité. Ils sont obligatoires pour permettre certaines fonctionnalités de l’Application et afin d’en assurer la sécurité.\nDes Traceurs dits fonctionnels sont également utilisés et permettent d’améliorer et d’optimiser votre expérience sur l’Application, ou sont nécessaires pour l’utilisation de certaines fonctionnalités.\n\nLes Outils de traçage de sécurité et fonctionnels sont strictement nécessaires à la fourniture des services Tales Up sur l’Application, ainsi vous ne pouvez pas refuser la collecte des Identifiants et l’utilisation des Traceurs de sécurité ou fonctionnels.\n\nCertains Traceurs sont spécifiques à l’Application, le cas échéant cela est indiqué dans leur finalité ci-dessous. \n\n-Facebook Login: Facebook, Fonctionnel, permettre l'inscription via Facebook\n-Google Firebase, Google, Fonctionnel, Envoyer des notifications push aux utilisateurs\n-Sign in with Google: Google, Fonctionnel,Permettre l’inscription via Google Sign-in\n\nBesoins analytiques:\n\nPériple Studio utilise des Traceurs de mesure d’audience pour obtenir des informations sur le parcours des utilisateurs, pour analyser le trafic sur l’Application et à des fins de mesures d’audience. Cela permet à Périple Studio d’améliorer l'Application selon les demandes et besoins des utilisateurs.\n\nCertains Traceurs sont spécifiques à l’Application ole cas échéant cela est indiqué dans leur finalité ci-dessous.\n\nVotre consentement est demandé pour la collecte des Identifiants et l’utilisation des Traceurs à des fins analytiques.\n\n-Facebook: Facebook, Mesure, mesure d'audience et attribution\n-Google Firebase Analytics : Google, Mesure, Mesure d'audience et attribution",
    },
    {
        name: "4. Comment gérer vos cookies et l'utilisation de vos Identifiants ?",
        text: "Lors de l’inscription sur l’Application, un écran de consentement aux traceurs vous propose d’accepter, de refuser ou de paramétrer l’utilisation des Traceurs qui ne sont pas essentiels au fonctionnement stable de l’Application.\nEn cas de nouvelle connexion sur l’Application après une déconnexion, l’écran sera affiché de nouveau et vous proposera d’accepter, de refuser ou de paramétrer l’utilisation de Traceurs.\n\nLe consentement que vous fournissez pour l’utilisation de Traceurs analytiques et publicitaires peut être retiré à tout moment.\nDepuis l’Application, Il vous suffit de cliquer sur le lien « Menu > À propos > Gérer mes choix ».\n\nÀ l’exception des Traceurs utilisés à des fins de mesures d’audience et publicitaires, tous les Traceurs de l’Application listés précédemment sont indispensables au fonctionnement stable et à l’exploitation des Services de l’Application auxquels vous avez souscrit.\n\nPour les Traceurs à des fins publicitaires, vous pouvez également configurer votre appareil afin de refuser la publicité personnalisée :\n\nPour Apple/ iOS :\n-Aller dans Réglages >  Confidentialité > Publicité\n-Activer « Suivi publicitaire limité »\n\nPour Android / Google Play Store :\n-Aller dans Paramètres > Compte ou Synchronisation ou Google (selon votre appareil) > Confidentialité ou Publicité ou Annonces (selon votre appareil)\n-Activer « Désactiver la personnalisation des annonces »",
    },
    {
        name: "5. Contact",
        text: "Si vous avez des questions concernant la présente Charte ou une réclamation à propos des cookies et Outils de traçage, vous pouvez nous contacter :\n\n-En envoyant un e-mail à notre adresse email de contact : support@talesup.io\n-En envoyant un e-mail à notre référent à la protection des données : referent.donnees@talesup.io\n-En envoyant un courrier à l’adresse postale suivante :\nÀ l’attention du référent à la protection des données\nPériple Studio\n7 rue Viollet-le-Duc, Clermont-Ferrand\nFrance\n\nPour rappel, vous trouverez ci-dessous les informations concernant la société chargée d’appliquer cette Charte :\n\nSAS Périple Studio immatriculée sous le numéro 894 383 553 au RCS de Clermont-Ferrand, dont le siège social est situé au 7 rue Viollet-le-Duc, Clermont-Ferrand France et représentée par son président, Monsieur Victor Jaffeux.\n\nEnfin, n’oubliez pas de consulter notre Politique de confidentialité.",
    },
];

export const cookiesList = [
    {
        name: "Facebook",
        purpose: "Mesure d'audience et attribution",
    },
    {
        name: "Google Firebase Analytics",
        purpose: "Rapports de bugs, Mesure d'audience et attribution",
    },
];

// =======================================================

const gameExpiration = {
    quarterDay: 21600000,
    halfDay: 43200000,
    oneDay: 86400000,
    twoDay: 172800000,
};

export const GAME_ONLINE = {
    GAME_EXPIRATION_LENGTH: gameExpiration.oneDay,
    GAME_ID_LENGTH: 5,
    GAME_ID_PLACEHOLDER: "AAAAA",
};

// =======================================================

/* export const FIREBASE_DATABASE = {
  URL: 'https://talesup-dev-default-rtdb.europe-west1.firebasedatabase.app/',
  REFERENCES: {
    CHOICES: 'choices',
    PLAYERS_EXCLUDED: 'playersExcluded',
    PLAYERS_LOGOUT: 'playersLogout',
    GAMES: 'games',
    PLAYERS: 'players',
  },
}; */

export const COMPANIONS = {
    NBMAX: 12,
    PRICE: 25,
};

export const FIREBASE_DATABASE = {
    URL: "https://tales-up-demo.firebaseio.com/",
    REFERENCES: {
        CHOICES: "choices",
        PLAYERS_EXCLUDED: "playersExcluded",
        PLAYERS_LOGOUT: "playersLogout",
        GAMES: "games",
        PLAYERS: "players",
        GAME_CHATS: "gameChats",
    },
};

export const FRIENDS = {
    STATUS: {
        PENDING: 0,
        INVITED: 1,
        ACCEPTED: 2,
        DECLINED: -1,
    },
    TYPE: {
        ALL: "all",
        ACCEPTED: "accepted",
        CONNECTED: "connected",
    },
};

export const SORT = {
    TIME_ASC: "time_asc",
    TIME_DESC: "time_desc",
    STORY_ASC: "story_asc",
    STORY_DESC: "story_desc",
};

export const SOCKET_EVENTS = {
    CONNECT: "connect",
    LOGIN: "login",
    DISCONNECT: "disconnection",
    GAME_REQUEST: "inviteGameRequest",
    DECLINE_GAME_REQUEST: "declineGameRequest",
    HAS_DECLINED_GAME_REQUEST: "hasDeclinedGameRequest",
};

export const FTUE_MODALS = {
    LIBRARY: "library",
    GAME: "game",
    ONLINE: "online",
    SHOP: "shop",
    SOCIAL: "social",
    REWARDS: "rewards",
};

export const REFERRAL = {
    STATUS: {
        PENDING: 0,
        CLAIMED: 1,
        PLACEHOLDER: -1,
    },
};

export const MAIN_QUEST_LEVELS = [1, 2, 5, 9, 14, 20];

// =======================================================
